import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import matchPath from 'rudy-match-path' // Included with redux-first-router
import { selectLocationState } from 'redux-first-router'
import Link from 'redux-first-router-link'

// import defaultState from '@/state/reducers/resource/list/initialParams'
import toUrl from './toUrl'

const NavLink = (
  {
    to,
    href,
    pathname,
    className,
    style,
    activeClassName = 'active',
    activeStyle,
    ariaCurrent = 'true',
    exact,
    strict,
    isActive,
    includeQuery,
    tag: Tag = 'li',
    ...props
  },
  { store },
) => {
  to = href || to
  const state = store.getState()
  const location = selectLocationState(state)
  const path = toUrl(to, location.routesMap).split('?')[0]
  const match = matchPath(pathname, { path, exact, strict })
  const active = !!(isActive ? isActive(match, location) : match)

  if (includeQuery) {
    // to.query = state.rest[includeQuery].list.params
    const current = state.rest[includeQuery].list.params
    const defaultParams = current.default
    to.query = {
      ...(current.sort && current.sort !== defaultParams.sort && { sort: current.sort }),
      ...(current.order && current.order !== defaultParams.order && { order: current.order }),
      ...(current.page && current.page != defaultParams.page && { page: current.page }),
      ...(current.perPage &&
        current.perPage != defaultParams.perPage && { perPage: current.perPage }),
    }
  }

  const combinedClassName = active
    ? [className, activeClassName].filter(i => i).join(' ')
    : className

  const combinedStyle = active ? { ...style, ...activeStyle } : style

  return (
    <Tag className={combinedClassName} style={combinedStyle}>
      <Link to={to} aria-current={active && ariaCurrent} {...props} />
    </Tag>
  )
}

NavLink.contextTypes = {
  store: PropTypes.object.isRequired,
}

const mapState = state => ({ pathname: selectLocationState(state).pathname })

export default connect(mapState)(NavLink)



// WEBPACK FOOTER //
// ./ui/NavLink/index.js